import { render } from "./SocialShare.vue?vue&type=template&id=77f89395&scoped=true"
import script from "./SocialShare.vue?vue&type=script&lang=js"
export * from "./SocialShare.vue?vue&type=script&lang=js"

import "./SocialShare.vue?vue&type=style&index=0&id=77f89395&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f89395"]])

export default __exports__